import { render, staticRenderFns } from "./WPMiniHeader.vue?vue&type=template&id=ddf49738"
import script from "./WPMiniHeader.vue?vue&type=script&lang=ts"
export * from "./WPMiniHeader.vue?vue&type=script&lang=ts"
import style0 from "./WPMiniHeader.vue?vue&type=style&index=0&id=ddf49738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports